import axios from 'axios';

// Pagina "Analisi prezzi" eBay: inserzioni attive, prodotti seguiti, concorrenti per EAN
// e aggiustamento del prezzo. L'elenco lo aggiorna la scansione di "Associa prodotti"
// (marketplaceUnmatched/scan), la ricerca concorrenti un job in background.

const buildUrl = (context, path) => `${context.rootGetters['settings/getUrl']}ebayprice/${path}`;

const authHeader = context => ({ Authorization: `Bearer ${context.rootGetters['profile/getToken']}` });

const fail = err => {
	const detail = err?.response?.data?.error;
	return {
		error: Array.isArray(detail) ? detail.map(e => (typeof e === 'string' ? e : e.msg || e.param)).join(', ') : detail || err?.response?.status || true,
		status: err?.response?.status,
	};
};

const actions = {
	// avvia la ricerca concorrenti dei prodotti seguiti
	startAnalysis: async (context, { marketplace }) => {
		return await axios
			.post(buildUrl(context, 'analysis'), { marketplace }, { headers: authHeader(context) })
			.then(res => res.data)
			.catch(fail);
	},

	// prodotti, chiamate e tempo stimato: si mostra prima di lanciare
	analysisEstimate: async (context, { marketplace }) => {
		return await axios
			.get(buildUrl(context, 'analysis/estimate'), { headers: authHeader(context), params: { marketplace } })
			.then(res => res.data)
			.catch(fail);
	},

	// ultima scansione (condivisa con Associa prodotti) e ultima analisi del paese
	job: async (context, { marketplace }) => {
		return await axios
			.get(buildUrl(context, 'job'), { headers: authHeader(context), params: { marketplace } })
			.then(res => res.data)
			.catch(fail);
	},

	rows: async (context, { marketplace, page = 1, limit = 25, search = '', followed = false, compare = '' }) => {
		return await axios
			.get(buildUrl(context, 'rows'), {
				headers: authHeader(context),
				params: { marketplace, page, limit, search, followed, compare },
			})
			.then(res => res.data)
			.catch(fail);
	},

	follow: async (context, { id, followed }) => {
		return await axios
			.patch(buildUrl(context, `rows/${id}/follow`), { followed }, { headers: authHeader(context) })
			.then(res => res.data)
			.catch(fail);
	},

	// "Analizza ora": una sola riga, subito (stessa analisi del job)
	analyzeOne: async (context, { id }) => {
		return await axios
			.post(buildUrl(context, `rows/${id}/analyze`), {}, { headers: authHeader(context) })
			.then(res => res.data)
			.catch(fail);
	},

	// stessa modifica della pagina eBay (offerta Inventory API), diretta
	adjustPrice: async (context, { id, price }) => {
		return await axios
			.post(buildUrl(context, `rows/${id}/adjust-price`), { price }, { headers: authHeader(context) })
			.then(res => res.data)
			.catch(fail);
	},
};

export default {
	namespaced: true,
	actions,
};
